document.addEventListener("DOMContentLoaded", () => {


  const SUPABASE_URL = "https://vzrxmpgbtlexatwrnrtc.supabase.co";
  const SUPABASE_KEY = "sb_publishable_DhkeX77J-T_RWtcRLZA8UA_BnDDxVqM";


  const supabaseClient = supabase.createClient(
    SUPABASE_URL,
    SUPABASE_KEY
  );


  const container = document.getElementById(
    "artwork-voting-section"
  );


  if (!container) return;


  const votingId = container.dataset.votingId;


  const buttons = document.querySelectorAll(".vote-button");

  const submitButton = document.getElementById(
    "submit-votes"
  );


  const statusBox = document.getElementById(
    "vote-status"
  );


  let selections = {};


  const storageKey = "artwork_vote_" + votingId;



  /*
    Lade bestehende Ergebnisse immer
  */

  loadResults();



  /*
    Wenn bereits abgestimmt:
    Buttons deaktivieren
  */

  if (localStorage.getItem(storageKey)) {

    disableVoting();

  }



  /*
    Auswahl treffen
  */

  buttons.forEach(button => {


    button.addEventListener("click", () => {


      if (localStorage.getItem(storageKey)) {
        return;
      }


      const artworkId = button.dataset.artwork;

      const choice = button.dataset.choice;



      selections[artworkId] = choice;



      /*
        Andere Auswahl desselben Artworks entfernen
      */

      document
        .querySelectorAll(
          `[data-artwork="${artworkId}"]`
        )
        .forEach(btn => {

          btn.classList.remove("selected");

        });



      button.classList.add("selected");



    });


  });





  /*
    Abstimmung abschicken
  */


  submitButton.addEventListener(
    "click",
    async () => {


      if (
        Object.keys(selections).length === 0
      ) {

        statusBox.innerHTML =
          "Bitte wähle mindestens ein Artwork aus.";

        return;

      }



      if (
        localStorage.getItem(storageKey)
      ) {

        return;

      }




      const votes =
        Object.entries(selections)
          .map(([artworkId, choice]) => {


            return {

              voting_id: votingId,

              artwork_id: artworkId,

              choice: choice

            };


          });





      const { error } =
        await supabaseClient
          .from("votes")
          .insert(votes);





      if (error) {


        console.error(error);


        statusBox.innerHTML =
          "Fehler beim Speichern.";


        return;

      }





      localStorage.setItem(
        storageKey,
        "true"
      );



      disableVoting();



      statusBox.innerHTML =
        "Danke für deine Stimme!";



      loadResults();



    }

  );







  function disableVoting() {


    buttons.forEach(button => {

      button.disabled = true;

    });


    submitButton.disabled = true;


  }








  async function loadResults() {


    const { data, error } =
      await supabaseClient
        .from("votes")
        .select("*")
        .eq(
          "voting_id",
          votingId
        );



    if (error) {

      console.error(error);

      return;

    }





    const results = {};



    data.forEach(vote => {



      if (!results[vote.artwork_id]) {


        results[vote.artwork_id] = {

          A: 0,

          B: 0

        };

      }



      results[vote.artwork_id][vote.choice]++;



    });







    Object.entries(results)
      .forEach(([artworkId, result]) => {



        const total =
          result.A + result.B;



        const percentA =
          total
            ? Math.round(
                result.A / total * 100
              )
            : 0;



        const percentB =
          total
            ? Math.round(
                result.B / total * 100
              )
            : 0;





        let winner = "";



        if (percentA > percentB) {

          winner = "A";

        }


        if (percentB > percentA) {

          winner = "B";

        }





        const resultBox =
          document.querySelector(
            `[data-result="${artworkId}"]`
          );



        if (!resultBox) return;





        resultBox.innerHTML = `

          <h3>
            Aktuelles Ergebnis
          </h3>


          <div class="
            result-choice 
            ${winner === "A" ? "result-winner" : ""}
          ">

            A: ${percentA}%

            ${
              winner === "A"
              ? "🏆 Gewinner"
              : ""
            }

          </div>



          <div class="
            result-choice 
            ${winner === "B" ? "result-winner" : ""}
          ">

            B: ${percentB}%

            ${
              winner === "B"
              ? "🏆 Gewinner"
              : ""
            }

          </div>


        `;



      });



  }



});